<template>
  <v-container fluid class="employee-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Employee Information</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 3" step="3">Employee Details</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">Create New Employee</p>
                        <v-select
                          class="mb-4"
                          :items="users.filter(x=>x.userstatus=='Active').map(x => {return {text: x.userid, value: x._id};})"
                          v-model="employee.userid"
                          outlined
                          dense
                          placeholder="User Id"
                          persistent-hint
                          single-line hint="Please choose the User Id">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="employee.employeecode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Employee Code"
                          persistent-hint
                          single-line hint="Enter the employee code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="employee.employeename"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Employee Name"
                          persistent-hint
                          single-line hint="Enter the employee name">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="employee.employeetitle"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Title"
                          persistent-hint
                          single-line hint="Enter the employee title">
                        </v-text-field>
                      </v-form>
                      </v-col>
                      <v-col cols="12" md="3">
                        <p class="text-h5">&nbsp;</p>
                        <v-form>
                        <v-text-field
                          class="mb-4"
                          v-model="employee.employeepin"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Pin"
                          persistent-hint
                          single-line hint="Enter employee pin. Min 6 digits long">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=items
                          v-model="employee.employeetype"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the employee type">
                        </v-select>
                          <v-switch
                            v-model="employee.employeestatus"
                            color="primary"
                            v-bind:label="employee.employeestatus"
                            value="Active"
                          ></v-switch>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="6">    
                        <div class="d-flex justify-center">
                          <v-btn
                              to="/employee/list"
                              replace
                              outlined
                              color="primary"
                          >
                            Cancel
                          </v-btn>
                          <v-spacer></v-spacer>
                            <v-btn
                              class="button-shadow"
                              color="primary"
                              @click="checkError">
                              Next
                            </v-btn>
                        </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="step = 3"
                          >
                            Next
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Employee Details</p>
                        <v-textarea
                          v-model="employee.employeeaddress"
                          outlined
                          rows=3
                          label="Address"
                          hint="please enter the employee address"
                        ></v-textarea>
                        <v-text-field
                          v-model="employee.employeeemail"
                          class="mb-4"
                          outlined
                          dense
                          placeholder="Company Email"
                          persistent-hint
                          single-line hint="Please enter the employee company email">
                        </v-text-field>
                        <v-text-field
                          v-model="employee.employeeemail2"
                          class="mb-4"
                          outlined
                          dense
                          placeholder="Personal Email"
                          persistent-hint
                          single-line hint="Enter the employee personal email">
                        </v-text-field>
                        <v-text-field
                          v-model="employee.employeephone"
                          class="mb-4"
                          outlined
                          dense
                          placeholder="Phone"
                          persistent-hint
                          single-line hint="Enter the employee phone">
                        </v-text-field>
                        <v-text-field
                          v-model="employee.employeemobile"
                          class="mb-4"
                          outlined
                          dense
                          placeholder="Mobile"
                          persistent-hint
                          single-line hint="Enter the employee mobile">
                        </v-text-field>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 2"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createEmployee()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      employee: {
        employeestatus: 'Active'
      },
      items: ['Full Time', 'Part Time', 'Contract'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },
  computed: {
    ...mapState('Employee', ['isReceiving']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('Employee', ['createEmployeeRequest','getEmployeesRequest']),
    ...mapActions('User', ['getUsersRequest']),
    checkError(){
      if(!this.employee.employeecode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.employee.employeename){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.employee.employeetitle){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.employee.employeepin || this.employee.employeepin.length<6 ){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.employee.employeetype){
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    createEmployee() {
      console.log(this.employee)
      this.createEmployeeRequest(this.employee)
      this.getEmployeesRequest()
      router.push('/employee/list')
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.employee.employeeimage = file;
      this.employee.imagename = file.name;
      this.createImage(file);
    }
  },
  async created(){
    if(this.users.length == 0) this.getUsersRequest();
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
